import 'fslightbox';
import './navigation';
import './sentry';

window.addEventListener('cc:onChange', () => location.reload());
